import {
  Badge,
  Box,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  FormGroup,
  InputBase,
  Tooltip,
  Typography,
  alpha,
  styled,
} from "@mui/material";
import React, { useState, useEffect } from "react";
import { Icon } from "@iconify/react";
import SearchIcon from "@mui/icons-material/Search";
import SimpleBar from "simplebar-react";
import { BsFillChatTextFill } from "react-icons/bs";
import { useDispatch, useSelector } from "react-redux";
import { setPackages, setRequests } from "../../../store/commonSlice";
import { useShoppingChatData } from "./hooks/useShoppingChatData";
import { useShoppingPackages } from "./hooks/useShoppingPackages";
import { formatDateTime } from "./utils/shoppingUtils";

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: "12px",
  backgroundColor: "#FAFAFA",
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  marginRight: "12px",
  // width: "230px",
  height: "40px",
  [theme.breakpoints.up("sm")]: {
    // marginLeft: theme.spacing(1),
    // width: "auto",
  },
  border: "1px solid #EEEEEE",
}));

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  width: "100%",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    [theme.breakpoints.up("sm")]: {
      // width: "12ch",
      "&:focus": {
        // width: "20ch",
      },
    },
  },
}));

const PackagesShopping = ({
  packageClickHandler,
  historyClickHandler,
  chatClickHandler,
  selectedFilters,
}) => {
  const dispatch = useDispatch();
  const {
    packages,
    selectedRequest: userActiveData,
    selectedPackage: packageActiveData,
  } = useSelector((state) => state.common);
  const [searchValue, setSearchValue] = useState("");
  const [isClickOnChat, setIsClickOnChat] = useState(false);
  const [tooltipText, setTooltipText] = useState({});

  // Use custom hooks
  const { unreadCounts, readStatusChange } = useShoppingChatData(
    packageActiveData?.id
  );
  const loading = useShoppingPackages();

  // Cleanup on unmount
  useEffect(() => {
    return () => {
      dispatch(setRequests([]));
      dispatch(setPackages([]));
    };
  }, [dispatch]);
  
  const filterPackages = packages?.filter((item) =>
    item?.id?.toLowerCase().includes(searchValue?.toLowerCase())
  );
  // const filterPackages = packages
  console.log(filterPackages, "filterPackages");

  const handleIconClick = (id, trackingId) => {
    navigator.clipboard.writeText(trackingId);
    setTooltipText((prev) => ({ ...prev, [id]: "Copied!" }));
    setTimeout(() => {
      setTooltipText((prev) => ({ ...prev, [id]: "Copy" }));
    }, 2000);
  };

  return (
    <div>
      <Box sx={{ p: "12px 0px 12px 12px" }}>
        <Typography variant="h5" sx={{ mb: "16px", ml: "12px" }}>
          Select Request
        </Typography>
        <Box>
          <Search>
            <SearchIconWrapper>
              <SearchIcon />
            </SearchIconWrapper>
            <StyledInputBase
              placeholder="Search Tracking and package ID"
              inputProps={{ "aria-label": "search" }}
              value={searchValue}
              onChange={(e) => setSearchValue(e.target.value)}
            />
          </Search>
        </Box>
        <FormGroup sx={{ mt: "8px" }}>
          {loading ? (
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                mt: "16px",
              }}
            >
              <CircularProgress size={30} />
            </Box>
          ) : (
            <SimpleBar
              forceVisible="y"
              autoHide={true}
              style={{ maxHeight: "80vh", width: "100%" }}
            >
              {filterPackages && filterPackages.length > 0 ? (
                filterPackages?.map((item, index) => {
                  return (
                  <Box
                    key={index}
                    sx={{
                      position: "relative",
                      mr: "12px",
                      mt: "8px",
                    }}
                    onClick={() => {
                      packageClickHandler(item?.id, item);
                      setIsClickOnChat(false);
                    }}
                  >
                    <Box
                      sx={{
                        borderRadius: "4px",
                        display: "flex",
                        padding: "8px 12px 8px 12px",
                        overflow: "hidden",
                        cursor: "pointer",
                        border:
                          packageActiveData?.id === item?.id
                            ? "1px solid #481AA3"
                            : "1px solid #EEEEEE",
                        backgroundColor:
                          packageActiveData?.id === item?.id && "#EBE4FA",
                      }}
                    >
                      <FormControlLabel
                        control={
                          <Checkbox
                            size="small"
                            sx={{
                              "& .MuiCheckbox-sizeSmall": {
                                border: "1px solid #E5E5E8",
                              },
                            }}
                          />
                        }
                        label={
                          <Typography variant="subtitle2">
                            {item?.packageId ? item?.packageId : "-"}
                          </Typography>
                        }
                        sx={{
                          color: "primary.main",
                        }}
                      />
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                        }}
                      >
                        <Box sx={{ display: "flex", gap: "1px" }}>
                          <Typography variant="subtitle1">
                            {item?.id}
                          </Typography>
                          <Tooltip
                            title={tooltipText[item?.id] || "Copy"}
                            arrow
                            placement="right"
                          >
                            <Icon
                              icon="material-symbols:content-copy-outline-sharp"
                              width={16}
                              height={16}
                              onClick={(e) => {
                                e.stopPropagation();
                                handleIconClick(
                                  item?.id,
                                  item?.id
                                );
                              }}
                              style={{ cursor: "pointer", color: "#828282" }}
                            />
                          </Tooltip>
                        </Box>
                        <Typography
                          variant="subtitle1"
                          sx={{ color: "#8C8C8C" }}
                        >
                          {(item.requestedAt||item?.createdAt) ? formatDateTime(item.requestedAt||item?.createdAt) : "-"}
                        </Typography>
                        <Box
                          sx={{ mt: "4px", cursor: "pointer" }}
                          onClick={(e) =>
                            historyClickHandler(item?.id, item, e)
                          }
                        >
                          <Typography
                            variant="h6"
                            sx={{ fontWeight: 600, color: "primary.main" }}
                          >
                            See history
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        onClick={(e) => {
                          readStatusChange(item?.id);
                          chatClickHandler(e, item?.id, item);
                        }}
                        sx={{
                          ml: "auto",
                          cursor: "pointer",
                        }}
                      >
                        <Badge
                          color="secondary"
                          badgeContent={
                            unreadCounts[item.id]
                              ? unreadCounts[item.id]
                              : 0
                          }
                          sx={{
                            "& .MuiBadge-badge": {
                              fontSize: "10px",
                              fontWeight: 600,
                              minWidth: 15,
                              height: 15,
                              mt: "2px",
                            },
                          }}
                        >
                          <BsFillChatTextFill size={20} color="#959BA1" />
                        </Badge>
                      </Box>
                    </Box>
                  </Box>
                );
              })
            ) : (
              <Box sx={{ textAlign: "center", mt: "20px" }}>
                No Packages Found
              </Box>
            )}
            </SimpleBar>
          )}
        </FormGroup>
      </Box>
    </div>
  );
};

export default PackagesShopping;
